import RecipeCard from "./RecipeCard";

export default RecipeCard;
